$(function () {
    $('.btn-letter a').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 190
                }, 400);
                return false;
            }
        }
    });
    $('.main-marcas__list__block__list').each(function() {
        var text = $(this).text(); 
        if($.trim(text) === "") {
            $(this).closest(".main-marcas__list__block").hide();
          }
       
     });
     $('.main-marcas__list__block').animate({opacity: 1}, 100);
});